export type LoadScriptReponse<T> = T

export const loadScript = <T>(src: string, n: T) =>
  new Promise<LoadScriptReponse<T>>((resolve, reject) => {
    const s = document.createElement('script')
    s.type = 'text/javascript'
    s.src = src
    s.onerror = err => {
      reject(err)
    }
    s.onload = () => {
      resolve(n)
    }
    const head = document.getElementsByTagName('head')[0]
    head.appendChild(s)
  })

export type LoadCssReponse<T> = T

export const loadCss = <T>(src: string, n: T) =>
  new Promise<LoadCssReponse<T>>((resolve, reject) => {
    const s = document.createElement('link')
    s.href = src
    s.rel = "stylesheet"
    s.type ="text/css";
    s.onerror = err => {
      reject(err)
    }
    s.onload = () => {
      resolve(n)
    }
    const head = document.getElementsByTagName('head')[0]
    head.appendChild(s)
  })
